export const QUESTIONNAIRE_FLOAT_EXP_LOG_KEY = "/ifission.ifission.QuestionnaireFloatExp";
export const QUESTIONNAIRE_FLOAT_CLK_LOG_KEY = "/ifission.ifission.QuestionnaireFloatClk";

/**
 *
 * @param {string} key - 黄金令箭的 logKey
 * @param {'CLK'|'EXP'} type - 打点类型
 * @param {Object} param - 打点的入参
 * @param {'GET'|'POST'} method - 打点请求类型
 * @returns {*}
 */
export const logRecord = (key, type, param, method) => {
  if (window.goldlog && window.goldlog.record && typeof window.goldlog.record === "function") {
    const logParams = new URLSearchParams(param).toString();
    window.goldlog.record(key, type, logParams, method);
  }
};

/**
 * 黄金令箭曝光打点方式
 * @param {string} key - 黄金令箭的 logKey
 * @param {Object} params - 打点的入参
 */
export const logExp = (key, params) => {
  logRecord(key, "EXP", params, "GET");
};

/**
 * 黄金令箭点击打点方式
 * @param {string} key - 黄金令箭的 logKey
 * @param {Object} params - 打点的入参
 */
export const logClk = (key, params) => {
  logRecord(key, "CLK", params, "GET");
};

/**
 * 未登录offer点击打点
 * @param {Object} params - 打点的入参
 * @param {string} params.offerId - offerId
 * @param {string} params.cna - cna
 * @param {string} params.position - position
 * @param {string} params.from - 来源
 * @param {string} params.isLogin - 是否登录
 */
export const offerClickLog = (params) => {
  logClk("/ifission.ifission.pcPage.userClickInfo", params);
};

export const questionnaireFloatClkGoldlog = (params) => {
  logClk(QUESTIONNAIRE_FLOAT_CLK_LOG_KEY, params);
};

export const questionnaireFloatExpGoldlog = (params) => {
  logExp(QUESTIONNAIRE_FLOAT_EXP_LOG_KEY, params);
};

export const goldlogAutoExpInit = () => {
  window.jplus || (window.jplus = {});
  window.jplus.plugin || (window.jplus.plugin = {});
  window.jplus.plugin.exp || (window.jplus.plugin.exp = []);

  window.jplus.plugin.exp.push({
    config: {
      selector: '.questionnaire-float-auto-exp',
      visible: '0.3',
      duration: '300',
      propsMap: {
        url: 'data-track-param'
      },
    },
    expWillRecord: (_element, _index, attributes = {}) => {
      if (attributes["data-track-param"]) {
        questionnaireFloatExpGoldlog(attributes["data-track-param"]);
      }
    },
  });
};
